import React, { useEffect, useState, Fragment } from 'react';

//*MUI
import { Box, Checkbox, Divider } from '@mui/material';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './BulkTokenRefund.module.css';
import ThreeDotsMenu from '../../../Subcomponents/ThreeDotsMenu';
import Datagrid from '../../../Subcomponents/Datagrid';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import LaunchesIcon from "../../../Assets/Images/Common/noProjectFound.svg";
import {
  getAllTokensByEvent,
  getEventByEventName,
  updateRefundToken,
} from '../../../Services/Event';
import SiteVisitIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import { useParams } from 'react-router-dom';
import { debounce, findIndex, indexOf, sortBy } from 'lodash';
import { errorTost, successTost } from '../../../Services/Toast';
import LeadStatusChip from '../../../Subcomponents/LeadStatusChip';
import Dot from '../../Icons/Dot';
import { addLeadLogs, updateLeadAllStatus } from '../../../Services/Lead';
import {
  getLinkedTokenDetails,
  updateEventLeadToken,
  updateEventLeadTokenGroup,
  updateLeadTokenStatus,
} from '../../../Services/AssignNewToken';
import { refundTokenPayment } from '../../../Services/PaymentApi';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import Button from '../../../Subcomponents/Button';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';

function BulkTokenRefund() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  const [NoTokenRefundRequests, setNoTokenRefundRequests] = useState(null);
  const [refundTokenArr, setRefundTokenArr] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [queryPage, setQueryPage] = useState(0);

  const [filterBy, setFilterBy] = useState('Latest First');
  const [search, setSearch] = useState('');
  const [TotalCount, setTotalCount] = useState(0);
  const [EventName, setEventName] = useState('');
  const { eventID } = useParams();
  const [loadingBulk, setLoadingBulk] = useState(false);
  const [approveConfirmationAlertToggle, setApproveConfirmationAlertToggle] =
  useState(false);
  useEffect(() => {
    dispatch(action.activeMenu('bulktokenrefund'));
    // console.log({ eventID }, useParams);
    getAllEventToken(false, search, filterBy);
    getEventName();
    console.log("Refund-Token-arr" , refundTokenArr)
  }, []);

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  const refundRequestColumns = [
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            <Checkbox
              sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
              style={{ fontSize: '1.4rem' }}
              checked={params.row.selected}
              onChange={(e) => {
                setRefundTokenArr((pre) => {
                  pre[
                    refundTokenArr.findIndex(
                      (el) => el.paymentId === params.row.paymentId
                    )
                  ].selected = e.target.checked;
                  return [...pre];
                });
              }}
            />
          </div>
        );
      },
    },
    {
      field: 'leadName',
      headerName: 'Lead Name',
      width: 280,
      renderCell: (params) => {
        return (
          <div>
            <div>{params.row.leadName}</div>
            <div>{params.row.leadId}</div>
          </div>
        );
      },
    },
    {
      field: 'tokenNumber',
      headerName: 'Token Number',
      width: 300,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status === 'active' && (
              <LeadStatusChip
                style={{ color: '#027A48', backgroundColor: '#ECFDF3' }}
                label={params.row.status}
                icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
              />
            )}
          </div>
        );
      },
    },
    {
      field: 'amountPaid',
      headerName: 'Amount Paid',
      width: 250,
      renderCell: (params) => {
        return <div>₹{numberWithCommas(params.row.amountPaid)}</div>;
      },
    },
  ];



  function BulkRefundTokens() {
    // ??only selected once
    let filteredTokens = refundTokenArr.filter(({ selected }) => selected === true);
    let count = 0;
    console.log({ filteredTokens });
    if (filteredTokens.length > 0) {
      setLoadingBulk(true);
      presentLoader();
      filteredTokens.forEach((lead) => {
        //! **Bulk Request query
        //??Refund Api call then update Lead status after success of refund token which will from siddharth side
        // !!Adding Refund Token api
        let body = {
          mode: 'Token',
          paymentId: lead?.paymentId,
        };
        count = count + 1;
        refundTokenPayment(body)
          .then((respRefundTokenPay) => {
            console.log("resRefundTokenPay" , respRefundTokenPay)
            console.log('count', count);
            console.log('filteredTokens', filteredTokens.length
            );
            if(respRefundTokenPay?.data?.success?.length) {
              if (count === filteredTokens.length) {
                // !!All Updates are Handled by Siddarth's refundtokenpayment api
                successTost('Bulk token refund done successfully');
                setLoadingBulk(false);
                getAllEventToken(false, search, filterBy);
                dismissLoader();
              }
            } else if(respRefundTokenPay?.data?.failed?.length) {
              if(count === filteredTokens.length) {
                errorTost(respRefundTokenPay?.data?.failed[0]?.reason)
                setLoadingBulk(false);
                getAllEventToken(false, search, filterBy);
                dismissLoader();
              } 
            }
          })
          .catch((err) => {
            errorTost(err?.data?.message);
            setLoadingBulk(false);
            dismissLoader();
          });
      });
    } else {
      errorTost('Please select at least one token to refund');
    }
  }

  function getEventName() {
    getEventByEventName(eventID).then((response) => {
      console.log('Event-Name', response[0].title);
      setEventName(response[0].title);
    }).catch((err) => {
      console.error("getEventByEventName" , err)
    });
  }

  function getAllEventToken(merge, search, filterBy) {
    getAllTokensByEvent(
      eventID,
      queryPage,
      filterBy,
      search,
      loggedInUser.userId
    ).then((responseToken) => {
      console.log('All Tokens by event', responseToken);

      // if (responseToken.count > 0) {
      //   setNoTokenRefundRequests(true);
        // &&el.userId!==null
        responseToken = responseToken.data.filter((el) => {
          return (
            el.leadId !== null &&
            el?.leadId?.personId !== null &&
            el?.eventTokenId !== null &&
            el?.eventTokenId?.tokenId !== null
          );
        });
        responseToken = responseToken.map((each) => ({
          ...each,
          id: each?.paymentId,
          leadName: each?.leadId?.personId?.name,
          leadId:
            'VJ' +
            each?.leadId?.leadDisplayId?.replace(
              each?.leadId?.leadDisplayId?.substring(8, 12),
              '-' + each?.leadId?.leadDisplayId?.substring(8, 12)
            ),
          tokenNumber: each?.tokenNumber,
          requestRaisedBy: each?.userId?.name,
          tokenStatus: each?.status,
          amountPaid: each?.paidAmount,
          selected: true,
        }));
        console.log('All Tokens by event', responseToken);
        if (filterBy.includes('Name')) {
          if (filterBy.includes('Ascending')) {
            responseToken = sortBy(responseToken, 'leadName');
          } else {
            responseToken = sortBy(responseToken, 'leadName').reverse();
          }
        }
        if (filterBy.includes('Latest')) {
          if (filterBy.includes('Ascending')) {
            responseToken = sortBy(responseToken, 'last_updated_at');
          } else {
            responseToken = sortBy(responseToken, 'last_updated_at').reverse();
          }
        }

        setTotalCount(responseToken.length);
        if(responseToken.length) {
          setNoTokenRefundRequests(true);
        } else {
          setNoTokenRefundRequests(false);
        }
        setRefundTokenArr([...responseToken]);
        if (!merge) {
          setRefundTokenArr([...responseToken]);
        } else {
          setRefundTokenArr((pre) => {
            return [...pre, ...responseToken];
          });
        }
      // } else {
      //   setNoTokenRefundRequests(false);
      // }
    }).catch((err) => {
      console.error("getAllTokensByEvent" , err)
    });
  }

  function pageChanged(e) {
    setCurrentPage(e);
    if (queryPage < e) {
      setQueryPage(e);
    }
  }

  const debouncedFetchSearchData = debounce((e) => {
    let searchData = e.target.value;
    setSearch(searchData);
    getAllEventToken(false, searchData, filterBy);    
  }, 800);
  

  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.HeaderTitle}>{EventName}</Box>
      </Box>

      <Divider />

      <Fragment>
        <Box margin={'1.3rem 0'}>
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.SubHeaderTitle} mt={3.5}>
              {TotalCount} Bulk Refund Tokens
            </Box>
            <Box className={cssClasses.flexCol}>
              <Box className={cssClasses.SubTitle} marginLeft={'2rem'}>
                Sort by
              </Box>
              <Box width={'250px'} margin={'0 2rem'}>
                <DropDown
                  list={[
                    'Name Ascending',
                    'Name Descending',
                    'Latest First',
                    'Oldest First',
                  ]}
                  style={{
                    selectedColor: '#175CD3',
                    background: '#E8F0FE',
                  }}
                  onChangeSelect={(value) => {
                    setFilterBy(value);
                    getAllEventToken(false, search, value);
                  }}
                  selectedValue={filterBy}
                />
              </Box>
            </Box>

            <Box
              marginLeft={'auto'}
              marginTop={'2.2rem'}
              style={{
                display: 'flex',
                gap: '1rem',
                alignItems: 'flex-end',
              }}
            >
              {NoTokenRefundRequests && (
                <div>
                  <Button
                    style={{
                      color: '#fff',
                      backgroundColor: '#1570EF',
                      fontSize: '1.4rem',
                      lineHeight: '2rem',
                      fontFamily: 'Inter-Medium !important',
                    }}
                    btnName={'Bulk Refund'}
                    isLoading={loadingBulk}
                    disable={loadingBulk}
                    clicked={() => {
                      let filteredTokens = refundTokenArr.filter(({ selected }) => selected === true);
                      if(filteredTokens.length > 0) {
                        setApproveConfirmationAlertToggle(true)
                      } else {
                        errorTost('Please select at least one token to refund');
                      }
                      
                    }}
                  />
                </div>
              )}
              <SearchBar
                placeholder={'Search by lead name'}
                search={debouncedFetchSearchData}
                id={'refundRequestLeads'}
              />
            </Box>
          </Box>
        </Box>

        {NoTokenRefundRequests && (
           <Box className={cssClasses.GridWrapper}>
           <Datagrid
             rows={refundTokenArr}
             columns={refundRequestColumns}
             pageSize={10}
             rowsPerPageOptions={[10]}
             page={currentPage}
             onPageChange={(e) => {
               pageChanged(e);
             }}
             hideFooter={false}
           />
         </Box>
        )}

        {(NoTokenRefundRequests === false) && (
           <Box>
           <Box className={cssClasses.noDataMsg}>
             <Box className={cssClasses.emptyIcon}>
               <img src={LaunchesIcon} alt="No Launches Available" />
             </Box>
             <Box className={cssClasses.emptyTitle}>No Bulk Refund Tokens were Found</Box>
           </Box>
         </Box>
        ) }

      {approveConfirmationAlertToggle && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              BulkRefundTokens()
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Confirm"}
          close={() => {
            setApproveConfirmationAlertToggle(false);
          }}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to Bulk Refund ${refundTokenArr.filter(({ selected }) => selected === true).length } Tokens?`}
          open={approveConfirmationAlertToggle}
        />
      )}
       
      </Fragment>
    </Box>
  );
}

export default BulkTokenRefund;
